import {
  type CoreUserDDB,
  LandingPageEnum,
  ThemeEnum,
} from '../interfaces/user.interface';

export const initialLoginState: CoreUserDDB = {
  bio: '',
  createdAt: '',
  interests: [],
  memberSince: '',
  accessToken: '',
  refreshToken: '',
  id: '',
  newUser: undefined,
  username: '',
  lastActive: undefined,
  userPreferences: {
    theme: ThemeEnum.LIGHT,
    landingPage: LandingPageEnum.FEED,
  },
  reputation: {
    sentiment: '',
    volatilityIndex: '',
    metrics: {
      following: [''], // referenced by IDs
      followers: [''], // referenced by IDs
    },
  },
  active: false,
  avatar: '',
  companyName: '',
  country: '',
  zipPostalCode: '',
  email: '',
  firstName: '',
  jobTitle: '',
  lastName: '',
  phoneNumber: '',
  role: undefined,
};
